module.exports = __webpack_public_path__ + "static/media/dayachocolates-banner.d96cddfc.jpg";